var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nup_main" }, [
    _c(
      "div",
      { staticClass: "nupm_projectNav f_l" },
      [
        _c("div", { staticClass: "nupmpn_title" }, [_vm._v("项目导航")]),
        _vm._v(" "),
        _c(
          "el-menu",
          {
            ref: "cmp_menu",
            staticClass: "cmp_menu",
            attrs: {
              "default-active": _vm.subId,
              "collapse-transition": "",
              "unique-opened": ""
            },
            on: { close: _vm.handleClick, open: _vm.handleClick }
          },
          [
            _c(
              "el-submenu",
              {
                class: ["all_subject", { submenu_selected: _vm.subId === "" }],
                attrs: { index: "" },
                on: {
                  click: function($event) {
                    return _vm.handleClick("")
                  }
                }
              },
              [
                _c("template", { slot: "title" }, [
                  _c("span", [_vm._v("全部学科")])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.disciplineCategoryList, function(item) {
              return _c(
                "el-submenu",
                {
                  key: item.id,
                  class: { submenu_selected: _vm.subId === String(item.id) },
                  attrs: { index: String(item.id) }
                },
                [
                  _c("template", { slot: "title" }, [
                    _c("span", [_vm._v(_vm._s(item.name))])
                  ]),
                  _vm._v(" "),
                  _vm._l(item.childs, function(itemc) {
                    return _c(
                      "el-menu-item",
                      {
                        key: itemc.id,
                        attrs: { index: String(itemc.id) },
                        on: {
                          click: function($event) {
                            _vm.handleClick(String(itemc.id))
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_vm._v(_vm._s(itemc.name))]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            })
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "nupm_right f_r",
        attrs: { "element-loading-text": "拼命加载中" }
      },
      [
        _c("div", { staticClass: "nupmr_title" }, [
          _c(
            "a",
            {
              class: {
                new_myCourse_sel:
                  _vm.switchMyProject === false && _vm.menuType === "all"
              },
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.switchProjectType(false, "all")
                }
              }
            },
            [_vm._v("所有项目")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              class: {
                new_myCourse_sel:
                  _vm.switchMyProject === false && _vm.menuType === "recommend"
              },
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.switchProjectType(false, "recommend")
                }
              }
            },
            [_vm._v("推荐项目")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              class: { new_myCourse_sel: _vm.switchMyProject === true },
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.switchProjectType(true)
                }
              }
            },
            [_vm._v("我的项目")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              class: {
                new_myCourse_sel:
                  _vm.switchMyProject === false && _vm.menuType === "expert"
              },
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.switchProjectType(false, "expert")
                }
              }
            },
            [_vm._v("十堰专家讲座")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nupmr_main" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tabCode != 2,
                  expression: "tabCode!=2"
                }
              ],
              staticClass: "nupmrm_case"
            },
            [
              _c("p", { staticClass: "npm_case1" }, [
                _c(
                  "span",
                  { staticStyle: { color: "red", "font-weight": "normal" } },
                  [_vm._v(_vm._s(_vm.currentTraining.trainingNotice))]
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "npm_case1", attrs: { id: "new_projState" } },
                [
                  _c("span", [_vm._v("项目状态：")]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { class: { new_radio_sel: _vm.projState == "" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.projState,
                            expression: "projState"
                          }
                        ],
                        attrs: { name: "projState", type: "radio", value: "" },
                        domProps: { checked: _vm._q(_vm.projState, "") },
                        on: {
                          change: function($event) {
                            _vm.projState = ""
                          }
                        }
                      }),
                      _vm._v("全部")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { class: { new_radio_sel: _vm.projState == "4" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.projState,
                            expression: "projState"
                          }
                        ],
                        attrs: { name: "projState", type: "radio", value: "4" },
                        domProps: { checked: _vm._q(_vm.projState, "4") },
                        on: {
                          change: function($event) {
                            _vm.projState = "4"
                          }
                        }
                      }),
                      _vm._v("未学习")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { class: { new_radio_sel: _vm.projState == "1" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.projState,
                            expression: "projState"
                          }
                        ],
                        attrs: { name: "projState", type: "radio", value: "1" },
                        domProps: { checked: _vm._q(_vm.projState, "1") },
                        on: {
                          change: function($event) {
                            _vm.projState = "1"
                          }
                        }
                      }),
                      _vm._v("学习中")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { class: { new_radio_sel: _vm.projState == "2" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.projState,
                            expression: "projState"
                          }
                        ],
                        attrs: { name: "projState", type: "radio", value: "2" },
                        domProps: { checked: _vm._q(_vm.projState, "2") },
                        on: {
                          change: function($event) {
                            _vm.projState = "2"
                          }
                        }
                      }),
                      _vm._v("已学完")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { class: { new_radio_sel: _vm.projState == "3" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.projState,
                            expression: "projState"
                          }
                        ],
                        attrs: { name: "projState", type: "radio", value: "3" },
                        domProps: { checked: _vm._q(_vm.projState, "3") },
                        on: {
                          change: function($event) {
                            _vm.projState = "3"
                          }
                        }
                      }),
                      _vm._v("已申请")
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "npm_case2" }, [
                _c("span", [_vm._v("项目名称：")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.projParam,
                      expression: "projParam"
                    }
                  ],
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: "项目名称/项目负责人", type: "text" },
                  domProps: { value: _vm.projParam },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.projParam = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "button", value: "搜索" },
                  on: {
                    click: function($event) {
                      _vm.pagination.currentPage = 1
                      _vm.groomSearch()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "button", value: "重置" },
                  on: { click: _vm.resetParam }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nupmrm_content" },
            [
              _vm._l(_vm.projList, function(item, index) {
                return _vm.tabCode != 2
                  ? _c("div", { staticClass: "npc_box" }, [
                      _c(
                        "div",
                        { staticClass: "npcb_pic" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  path: "/usercenter/projectDtail",
                                  query: {
                                    trainingId: _vm.currentTraining.id,
                                    projectId: item.projId
                                  }
                                },
                                target: "_blank"
                              }
                            },
                            [_c("img", { attrs: { src: item.iamge } })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "npcb_txt" },
                        [
                          _c(
                            "router-link",
                            {
                              class: { projectName_top: item.setTop == 1 },
                              attrs: {
                                title: item.projectName,
                                to: {
                                  path: "/usercenter/projectDtail",
                                  query: {
                                    trainingId: _vm.currentTraining.id,
                                    projectId: item.projId,
                                    setTop: item.setTop
                                  }
                                },
                                target: "_blank"
                              }
                            },
                            [
                              _c("span", { staticClass: "npcbt_title" }, [
                                _vm._v(_vm._s(item.projectName))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "npcbt_info" }, [
                                _vm._v(
                                  "项目负责人：" +
                                    _vm._s(
                                      item.nickName ? item.nickName : "--"
                                    ) +
                                    "　　 项目类别：" +
                                    _vm._s(
                                      item.proCategoryName
                                        ? item.proCategoryName
                                        : "--"
                                    ) +
                                    "　　学分类别：" +
                                    _vm._s(
                                      item.creCategoryName
                                        ? item.creCategoryName
                                        : "--"
                                    ) +
                                    "　　学分：" +
                                    _vm._s(
                                      item.creditSetting
                                        ? item.creditSetting
                                        : "--"
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "npcb_status" }, [
                        item.projState == 0 || item.projState == null
                          ? _c("span", [_vm._v("【未学习】")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 1
                          ? _c("span", [_vm._v("【学习中】")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 2
                          ? _c("span", [
                              _vm._v("【已学完】"),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.applyScore(
                                        _vm.currentTraining.id,
                                        item.projId,
                                        item.creditCateggory,
                                        item.creditSetting
                                      )
                                    }
                                  }
                                },
                                [_vm._v("[申请学分]")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 3
                          ? _c("span", [
                              _vm._v("\n              【已申请】"),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelApplyScore(
                                        _vm.currentTraining.id,
                                        item.projId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("[取消申请]")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 4
                          ? _c("span", [_vm._v("【已授予】")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.isOwn == 1
                          ? _c("div", [
                              _vm.switchMyProject
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFromMyProject(
                                            item.proStateId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("[×删除项目]")]
                                  )
                                : _c("span", [_vm._v("【已加入我的项目】")])
                            ])
                          : _c(
                              "a",
                              {
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addToMyProject(
                                      _vm.currentTraining.id,
                                      item.projId
                                    )
                                  }
                                }
                              },
                              [_vm._v("[+添加到我的项目中]")]
                            )
                      ])
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.projListzj, function(item, index) {
                return _vm.tabCode == 2
                  ? _c("div", { staticClass: "npc_box" }, [
                      _c(
                        "div",
                        { staticClass: "npcb_pic" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  path: "/usercenter/projectDtail",
                                  query: {
                                    trainingId: _vm.currentTraining.id,
                                    projectId: item.projId,
                                    setTop: 1
                                  }
                                },
                                target: "_blank"
                              }
                            },
                            [_c("img", { attrs: { src: item.iamge } })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "npcb_txt" },
                        [
                          _c(
                            "router-link",
                            {
                              class: { projectName_top: item.setTop == 1 },
                              attrs: {
                                title: item.projectName,
                                to: {
                                  path: "/usercenter/projectDtail",
                                  query: {
                                    trainingId: _vm.currentTraining.id,
                                    projectId: item.projId,
                                    setTop: 1
                                  }
                                },
                                target: "_blank"
                              }
                            },
                            [
                              _c("span", { staticClass: "npcbt_title" }, [
                                _vm._v(_vm._s(item.projectName))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "npcbt_info" }, [
                                _vm._v(
                                  "项目负责人：" +
                                    _vm._s(
                                      item.nickName ? item.nickName : "--"
                                    ) +
                                    "　　 项目类别：" +
                                    _vm._s(
                                      item.proCategoryName
                                        ? item.proCategoryName
                                        : "--"
                                    ) +
                                    "　　学分类别：" +
                                    _vm._s(
                                      item.creCategoryName
                                        ? item.creCategoryName
                                        : "--"
                                    ) +
                                    "　　学分：" +
                                    _vm._s(
                                      item.creditSetting
                                        ? item.creditSetting
                                        : "--"
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "npcb_status" }, [
                        item.projState == 0 || item.projState == null
                          ? _c("span", [_vm._v("【未学习】")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 1
                          ? _c("span", [_vm._v("【学习中】")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 2
                          ? _c("span", [
                              _vm._v("【已学完】"),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.applyScore(
                                        _vm.currentTraining.id,
                                        item.projId,
                                        item.creditCateggory,
                                        item.creditSetting
                                      )
                                    }
                                  }
                                },
                                [_vm._v("[申请学分]")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 3
                          ? _c("span", [
                              _vm._v("\n              【已申请】"),
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelApplyScore(
                                        _vm.currentTraining.id,
                                        item.projId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("[取消申请]")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.projState == 4
                          ? _c("span", [_vm._v("【已授予】")])
                          : _vm._e(),
                        _vm._v(" "),
                        item.isOwn == 1
                          ? _c("div", [
                              _vm.switchMyProject
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFromMyProject(
                                            item.proStateId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("[×删除项目]")]
                                  )
                                : _c("span", [_vm._v("【已加入我的项目】")])
                            ])
                          : _c(
                              "a",
                              {
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.addToMyProject(
                                      _vm.currentTraining.id,
                                      item.projId
                                    )
                                  }
                                }
                              },
                              [_vm._v("[+添加到我的项目中]")]
                            )
                      ])
                    ])
                  : _vm._e()
              })
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38afa12c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38afa12c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CmePage.vue
// module id = null
// module chunks = 